import React from "react";
import NumberSpinner from "../../NumberSpinner/NumberSpinner";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
export default class RoomTypeBuilderCategory extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: true,
      amenities: []
    };
   
    this.onToggleCollapsed = this.onToggleCollapsed.bind(this);
  }

  render() {
    return (
      <div>
        {this.renderBody()}
      </div>
    );
  }

  renderArrow() {
    if (!this.state.collapsed) {
      return (
        <span className="bf-arrow-down" onClick={this.onToggleCollapsed}></span>
      );
    } else {
      return (
        <span
          className="bf-arrow-right"
          onClick={this.onToggleCollapsed}
        ></span>
      );
    }
  }

  renderBody() {
    var amenities = []
    this.state.amenities.map((categoryAmenity, idx) => {
      const roomAmenity = this.props.ru_amenities.find(roomAmenity => categoryAmenity.id == roomAmenity.id);

      if (!this.state.collapsed) {
        amenities.push(
          <div key={idx} className="col-sm-4 pb-4">
            <input
              id={categoryAmenity.id}
              data-amenity={categoryAmenity.name}
              data-otas={categoryAmenity.otas}
              type="checkbox"
              name="amenity"
              className="col-sm-1"
              onChange={this.props.onChangeAmenities}
              checked={roomAmenity ? true : false}
            />
            <div className="labels col-sm-11 pl-0">
              <label className="amenity-labels col-sm-12 pl-0">{categoryAmenity.name}</label>
              <p className="col-sm-12 ml-2 amenity-otas pl-0">{categoryAmenity.otas ? `${categoryAmenity.otas.join(", ")}` : ""}</p>
            </div>
            <div className="amenity-spinner col-sm-12">
              {roomAmenity ?
              <NumberSpinner
                id={categoryAmenity.id}
                name="ru_amenity"
                value={roomAmenity.count}
                onChange={this.props.onChange}
                min={1}
                max={999}
                />
                :
                null
              }
            </div>
          </div>
        );
      }
    });

    return (
      <div className="category">
        <LoadingSpinner show={this.state.loading} />
        <div className="row">
          <div className="col-md-12">
            <h3 className="name">{this.props.category.name}</h3>
            
            <div className="inline-details">
              <div className="row">
                {amenities}
              </div>
            </div>
          </div>
        </div>
        {this.renderArrow()}
      </div>
    );
  }

  /**
   * Change handlers
   */

  onToggleCollapsed(e) {
    var self = this;
    e.preventDefault();
    self.setState({ loading: true });
    if (self.state.amenities.length > 0) {
      self.setState({ collapsed: self.state.collapsed ? false : true, loading: false });
    } else {
      setTimeout(function () {
        $.ajax({
          type: "GET",
          dataType: 'json',
          url: self.props.category.data_path,
        }).done(function (data) {
          self.setState({ loading: false, amenities: data.category.amenities, collapsed: self.state.collapsed ? false : true });
        })
      });
    }
  }
}
